export default __webpack_public_path__ + "3bfb97dea402ec95c0ca3a08f0d54155.png";